/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-10-29 15:07:48                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-26 16:10:23                               *
 *****************************************************************************/


/* SUMMARY
  * Imports
  * Styles
  * Loading: loading component
*/

/* Imports */
import { Spinner } from "@material-tailwind/react";
/***/

/* Styles */
import "./Loading.scss";
/***/

/**
* Loading: loading component
* @param size - optionnal size in height/width tailwind 
*/
export default function Loading({
  size = "w-10 h-10"
}: {
  size?: string
}) {
  return (
    <div className="loading-component">
      <Spinner className={size}/>
    </div>
  );
}
/***/
